/**
 * Renders a single profile form group from profileFormGroups.ts.
 */
import type { Profile } from "@spork/s4p-server-sdk";
import { useTranslation } from "react-i18next";

import { ListSection } from "@/components/ui/list-section";
import type { ProfileFormGroupDefinition } from "../config/profileFormGroups";
import { renderProfileFormField } from "../lib/renderProfileFormField";
import type { ProfileFormFieldHandlers } from "../types/profileFormFieldHandlers";

type ProfileFormGroupProps = ProfileFormFieldHandlers & {
    person: Profile;
    group: ProfileFormGroupDefinition;
};

export function ProfileFormGroup({
    person,
    group,
    ...handlers
}: ProfileFormGroupProps) {
    const { t } = useTranslation();
    const rows = group.fields
        .map((field) => renderProfileFormField(person, field, handlers))
        .filter((row) => row != null);

    if (rows.length === 0) {
        return null;
    }

    return (
        <ListSection
            title={t(`profile.groups.${group.titleKey}`)}
            footer={group.footer}
        >
            {rows}
        </ListSection>
    );
}
